import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { UserResponse } from '../types';

export type LoginCredentialsDTO = {
  email?: string;
  password?: string;
  otp?: string;
  token?: string;
  type?: string;
  userData?: UserResponse;
};
export type RegisterCredentialsDTO = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

export const loginWithEmail: any = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  if (data.otp) {
    return axios.post('/verify-otp', data);
  }
  return axios.post('/login', data);
};

export type DTO = {
  email : string;
  isWeb: boolean;
};

export const getEmailLoginDetails = ({email, isWeb} : DTO): Promise<UserResponse> => {
  return axios.post(`/login` , {email, isWeb});
};



type UseOptions = {
  config?: MutationConfig<typeof getEmailLoginDetails>;
};

export const useLoginWithEmail= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getEmailLoginDetails,
  });
};



export type DTO1 = {
  email : string;
};

export const generateOtp = ({email} : DTO1): Promise<UserResponse> => {
  return axios.post(`/generate-otp` , {email});
};



type Use1Options = {
  config?: MutationConfig<typeof generateOtp>;
};

export const useGenerateNewOtp= ({ config }: Use1Options = {}) => {
  return useMutation({
    ...config,
    mutationFn: generateOtp,
  });
};
